<template>
	<div class="info-wrapper">
		<div class="toggle-wrapper">
			<div class="toggle-layer"><button class="btn red" :class="{ 'selected': isSelected === 'openserve' }" @click="isSelected = 'openserve'">Openserve prepaid</button></div>
			<div class="toggle-layer"><button class="btn red" :class="{ 'selected': isSelected === 'vumatel' }" @click="isSelected = 'vumatel'">Vuma reach prepaid</button></div>
		</div>

		<div class="prepaid-type" v-if="isSelected === 'openserve'">
			<div class="column left">
				<div class="box-wrap">
					<div class="box header">
						<span class="icon"><svg><use xlink:href="#openserve-tab"></use></svg></span>
					</div>
					<div class="box">
						<dl>
							<dt>14 Day internet access.</dt>
							<dd>Included with your Fibre installation.</dd>
						</dl>
						<span class="icon"><svg><use xlink:href="#calendar"></use></svg></span>
					</div>
					<div class="box">
						<dl>
							<dt>Top up as needed.<sup>1</sup></dt>
							<dd>7 day top up available for R109.00 once-off.</dd>
						</dl>
						<span class="icon"><svg><use xlink:href="#upload"></use></svg></span>
					</div>
					<div class="box">
						<dl>
							<dt>Shaping and prioritisation.<sup>2</sup></dt>
							<dd>First 200GB at 20Mbps. Thereafter uncapped at 4Mbps.</dd>
						</dl>
						<span class="icon"><svg><use xlink:href="#uncapped"></use></svg></span>
					</div>
					<div class="box">
						<dl>
							<dt>Payment method.<sup>3</sup></dt>
							<dd>Debit or credit card via Afrihost ClientZone.</dd>
						</dl>
						<span class="icon"><svg><use xlink:href="#payment-method"></use></svg></span>
					</div>
				</div>
			</div>
			<div class="column right">
				<div class="numbered">
					<h2 class="grey">1. Check Fibre coverage.</h2>
					<p class="grey">Use our <a href="#">Coverage Map</a> to find out if your area is Fibre ready and which providers are available.</p>
					<button class="btn primary">Check fibre coverage</button>
				</div>

				<div class="numbered">
					<h2 class="grey">2. Sign up with Afrihost.</h2>
					<p class="grey">We have affordable Fibre packages to choose from. Simply put in your address, and if you’re covered, we’ll take it from there and get you connected before you can say Pure Internet Joy.</p>
				</div>

				<div class="numbered">
					<h2 class="grey">3. Fibre installation.</h2>
					<p class="grey">There are three basic steps to getting Fibre, which begins with availability in your neighbourhood. Once the provider has done this initial installation, your area would be Fibre ready. The next step is to have a Fibre line brought onto your property. Once you've signed up for Prepaid Fibre with Afrihost, the relevant provider will be in touch to help you get the Fibre line installed to your premises.</p>
				</div>

				<div class="numbered">
					<h2 class="grey">4. Enjoy blazing-fast Fibre.</h2>
					<p class="grey">New Openserve Prepaid Fibre installations come with 14 days of internet access, so you can start experiencing blazing-fast Fibre immediately.</p>
				</div>

				<div class="numbered">
					<h2 class="grey">5. Top up via ClientZone.</h2>
					<p class="grey">Once your internet access expires, simply log into ClientZone or the Afrihost App and top up with a 7 day internet access for only R109.00 once-off. You can load a maximum of 6 top ups at a time.</p>
				</div>
			</div>
		</div>
		<div class="prepaid-type" v-if="isSelected === 'vumatel'">
			<div class="column left">
				<div class="box-wrap">
				<div class="box header">
					<span class="icon"><svg><use xlink:href="#vumatel-tab"></use></svg></span>
				</div>
				<div class="box">
					<dl>
						<dt>30 Day internet access.</dt>
						<dd>Included with your Fibre installation.</dd>
					</dl>
					<span class="icon"><svg><use xlink:href="#calendar"></use></svg></span>
				</div>
				<div class="box">
					<dl>
						<dt>Top up as needed.<sup>1</sup></dt>
						<dd>30 day top ups available. Price based on line speed.</dd>
					</dl>
					<span class="icon"><svg><use xlink:href="#upload"></use></svg></span>
				</div>
				<div class="box">
					<dl>
						<dt>Shaping and prioritisation.<sup>2</sup></dt>
						<dd>Uncapped. Unshaped. Unthrottled.</dd>
					</dl>
					<span class="icon"><svg><use xlink:href="#uncapped"></use></svg></span>
				</div>
				<div class="box">
					<dl>
						<dt>Payment method.<sup>3</sup></dt>
						<dd>Selected EasyPay paypoints.</dd>
					</dl>
					<span class="icon"><svg><use xlink:href="#payment-method"></use></svg></span>
				</div>
			</div>
			</div>
			<div class="column right">
				<div class="numbered">
					<h2 class="grey">1. Check Fibre coverage.</h2>
					<p class="grey">Use our <a href="#">Coverage Map</a> to find out if your area is Fibre ready and which providers are available.</p>
					<button class="btn primary">Check fibre coverage</button>
				</div>

				<div class="numbered">
					<h2 class="grey">2. Sign up with Afrihost.</h2>
					<p class="grey">We have affordable Fibre packages to choose from. Simply put in your address, and if you’re covered, we’ll take it from there and get you connected before you can say Pure Internet Joy.</p>
				</div>

				<div class="numbered">
					<h2 class="grey">3. Fibre installation.</h2>
					<p class="grey">There are three basic steps to getting Fibre, which begins with availability in your neighbourhood. Once the provider has done this initial installation, your area would be Fibre ready. The next step is to have a Fibre line brought onto your property. Once you've signed up for Prepaid Fibre with Afrihost, the relevant provider will be in touch to help you get the Fibre line installed to your premises.</p>
				</div>

				<div class="numbered">
					<h2 class="grey">4. Enjoy blazing-fast Fibre.</h2>
					<p class="grey">New Vuma Reach Prepaid Fibre installations come with 30 days of internet access, so you can start experiencing blazing-fast Fibre immediately.</p>
				</div>

				<div class="numbered">
					<h2 class="grey">5. Top up via ClientZone or EasyPay paypoints.</h2>
					<p class="grey">Once your internet access expires, you can purchase a 30 day internet access top up from selected EasyPay paypoints or by following the link in ClientZone. You can load a maximum of 6 top ups at a time.</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
    export default {
        data() {
        	return {
				isSelected: 'openserve',
			}
		}
    }
</script>
